import { Routes, Route } from 'react-router-dom';
import Protected from "./Protected";

import NotFound from './NotFound';
import Licences from './Licences';
import PrivacyPolicy from './PrivacyPolicy';
import Login from '../containers/Login';
import Home from '../containers/Home';
import Livemap from '../containers/Livemap';
import Liveroutes from '../containers/Liveroutes';
import ServiceCurve from '../containers/ServiceCurve';
import ServiceCurvePlanned from '../containers/ServiceCurvePlanned';
// import Heatmap from '../containers/Heatmap';
// import Chloropleth from '../containers/Chloropleth';
import DataTable from '../containers/DataTable';
import PonctualiteJour from '../containers/PonctualiteJour';
import PonctualiteRoute from '../containers/PonctualiteRoute';
import PonctualiteTrip from '../containers/PonctualiteTrip';
// import PonctualiteADRTL from '../containers/PonctualiteADRTL';
import ChargeJour from '../containers/ChargeJour';
import ChargeRoute from '../containers/ChargeRoute';
import ChargeTrip from '../containers/ChargeTrip';
import VehicleDays from '../containers/VehicleDays';
import VehicleOperation from '../containers/VehicleOperation';
import RouteOperation from '../containers/RouteOperation';
import BlockOperation from '../containers/BlockOperation';
import CancelledTrips from '../containers/CancelledTrips';
import Benchmarks from '../containers/Benchmarks';
import Trends from '../containers/Trends';
import ComparePeriods from '../containers/ComparePeriods';
import UserProfile from '../containers/UserProfile';

export default function Routing() {

  return (
    <Routes>

      <Route exact path="/" element={<Login />} />
      <Route exact path="/home" element={<Protected><Home /></Protected>} />
      <Route exact path="/livemap" element={<Protected><Livemap /></Protected>} />
      <Route exact path="/courbeservice" element={<Protected><ServiceCurve /></Protected>} />
      <Route exact path="/courbereelplanif" element={<Protected><ServiceCurvePlanned /></Protected>} />
      <Route exact path="/liveroutes" element={<Protected><Liveroutes /></Protected>} />
      <Route exact path="/ponctualitejour" element={<Protected><PonctualiteJour /></Protected>} />
      <Route exact path="/ponctualiteroute" element={<Protected><PonctualiteRoute /></Protected>} />
      <Route exact path="/ponctualitetrip" element={<Protected><PonctualiteTrip /></Protected>} />
      <Route exact path="/chargejour" element={<Protected><ChargeJour /></Protected>} />
      <Route exact path="/chargeroute" element={<Protected><ChargeRoute /></Protected>} />
      <Route exact path="/chargetrip" element={<Protected><ChargeTrip /></Protected>} />
      <Route exact path="/vehdays" element={<Protected><VehicleDays /></Protected>} />
      <Route exact path="/vehoperation" element={<Protected><VehicleOperation /></Protected>} />
      <Route exact path="/routeoperation" element={<Protected><RouteOperation /></Protected>} />
      <Route exact path="/blockoperation" element={<Protected><BlockOperation /></Protected>} />
      <Route exact path="/benchmarks" element={<Protected><Benchmarks /></Protected>} />
      <Route exact path="/datatable" element={<Protected><DataTable /></Protected>} />
      <Route exact path="/compareperiods" element={<Protected><ComparePeriods /></Protected>} />
      <Route exact path="/options" element={<Protected><UserProfile /></Protected>} />
      <Route exact path="/trends" element={<Protected><Trends /></Protected>} />
      <Route exact path="/cancelledtrips" element={<Protected><CancelledTrips /></Protected>} />
      <Route exact path="/licences" element={<Protected><Licences /></Protected>} />
      <Route exact path="/privacypolicy" element={<Protected><PrivacyPolicy /></Protected>} />
      <Route path="*" element={<NotFound />} />

    </Routes>
  );
}
